import React from 'react'
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import Tr from 'translations/Translations';
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";

function WorkableIconActivateButton(
    {
        tooltip = Tr('activate'),
        ...props
    }) {
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={ToggleOffIcon}
        {...props}
    />
}

WorkableIconActivateButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconActivateButton;